// Bridge so non-component code (e.g. the Vuex store) can trigger the global
// toast owned by App.vue. App.vue registers its showToast handler on mount.
let handler = null;

export const toastService = {
  register(fn) {
    handler = fn;
  },
  show(payload) {
    if (handler) handler(payload);
  },
};
